import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaMapMarkedAlt, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const SubdistrictList = () => {
  const [subdistricts, setSubdistricts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");

  // Fetch list
  useEffect(() => {
    fetch(`${BASE_URL}super_admin/get_all_subdistrict`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setSubdistricts(data.subdistricts || data))
      .catch((err) => console.error(err));
  }, []);

  // Start edit
  const handleEdit = (item) => {
    setEditId(item.subdistrict_id);
    setEditName(item.subdistrict_name);
  };

  // Cancel edit
  const handleCancel = () => {
    setEditId(null);
    setEditName("");
  };

  // Save edit
  const handleSave = async (id) => {
    try {
      const res = await fetch(
        `${BASE_URL}super_admin/edit_subdistrict/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ subdistrict_name: editName }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setSubdistricts((prev) =>
        prev.map((s) =>
          s.subdistrict_id === id
            ? { ...s, subdistrict_name: editName }
            : s
        )
      );

      handleCancel();
    } catch (error) {
      alert(error.message);
    }
  };

  // Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this subdistrict?"))
      return;

    try {
      const res = await fetch(
        `${BASE_URL}super_admin/delete_subdistrict/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to delete subdistrict");

      setSubdistricts((prev) =>
        prev.filter((s) => s.subdistrict_id !== id)
      );
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaMapMarkedAlt />
            </div>
            <div>
              <h4 className="admin-header-title">उपविभाग व्यवस्थापन (Subdistrict Management)</h4>
              <p className="admin-header-subtitle mb-0">
                जिल्हानिहाय प्रशासकीय उपविभागांची यादी व्यवस्थापित करा
              </p>
            </div>
          </div>

          <Link to="/subdistricts" className="btn-admin-add">
            <FaPlus /> नवीन उपविभाग जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {subdistricts.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणताही उपविभाग आढळला नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>जिल्हा (District)</th>
                    <th>उपविभाग नाव (Subdistrict Name)</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>

                <tbody>
                  {subdistricts.map((item, index) => (
                    <tr key={item.subdistrict_id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>

                      <td className="fw-bold text-dark">{item.district_name}</td>

                      <td>
                        {editId === item.subdistrict_id ? (
                          <input
                            type="text"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                          />
                        ) : (
                          <span className="fw-semibold text-dark">{item.subdistrict_name}</span>
                        )}
                      </td>

                      <td className="text-end">
                        {editId === item.subdistrict_id ? (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-view"
                              onClick={() => handleSave(item.subdistrict_id)}
                              title="जतन करा"
                            >
                              <FaCheck />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={handleCancel}
                              title="रद्द करा"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-edit"
                              onClick={() => handleEdit(item)}
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => handleDelete(item.subdistrict_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SubdistrictList;
